// extracted by mini-css-extract-plugin
export var coverStylesSection = "cover-module--coverStylesSection---mpzM";
export var coverVectorWrapper = "cover-module--coverVectorWrapper--jlmNo";
export var coverStylesHeading = "cover-module--coverStylesHeading--20-av";
export var coverStylesInner = "cover-module--coverStylesInner--9Xnqw";
export var coverFeatures = "cover-module--coverFeatures--OIEtV";
export var coverStylesSecurityInner = "cover-module--coverStylesSecurityInner--WHonL";